import React from "react";
import NsDashboardCard from "../../../components/NsDashboardCard";
import { AutoComplete } from "primereact/autocomplete";
import Translate from "../../../components/Translate";

export default function DashboardCercaKpiView({
                                                  gri,
                                                  items,
                                                  onClickCerca,
                                                  onAutocomplete,
                                                  onChangeAutocomplete,
                                                  translate,
                                              }) {

    return (
        <NsDashboardCard
            classiAggiuntive={"ns-dashboard--no-padding"}
        >
            <form
                style={{
                    margin: "0px"
                }}
            >
                <div className={"row"}>
                    <div className={"col-9"} style={{
                        display: "flex"
                    }}>
                        <i
                            className="fas fa-search pe-3"
                            style={{
                                alignContent: "center"
                            }}
                        />
                        <AutoComplete
                            className={"w-100 ns-input-no-border"}
                            value={gri}
                            suggestions={items}
                            completeMethod={onAutocomplete}
                            onChange={onChangeAutocomplete}
                            placeholder={translate("Cerca indicatore")}
                        />
                    </div>
                    <div className={"col-3 text-end"}>
                        <button
                            className={"btn btn-dark"}
                            onClick={onClickCerca}
                        >
                            <Translate>Cerca</Translate>
                        </button>
                    </div>
                </div>
            </form>
        </NsDashboardCard>
    );
}